export enum SubscriptionType {
    TRIAL = 'trial',
    COMMUNITY = 'community',
    FREE_SKU = 'automationkit',
    FEDRAMP = 'govcloud',
    DIRECT_BUY = 'directbuy',
}
